/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export enum EUserLikeType {
    LIKE = 1, // 点赞
    UNLIKE = 2, // 点踩
    UNDO_LIKE = 3, // 取消点赞
    UNDO_UNLIKE = 4, // 取消点踩
}

export interface IInput {
    feed_id: number;
    like_type: number; // 1 点赞 2 点踩 3 取消点赞 4 取消点踩
}

export interface IOutput {
    result: string;
}

export const userLike = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.USER_LIKE, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const userLikeSync = fetchDataSync(userLike);
